import { useState, useEffect, useRef } from 'react';
import { Card, Skeleton, Form, Input, Select, Upload, Button, Tree, Modal, message, TreeSelect } from 'antd';
import { FolderViewOutlined, InboxOutlined, DeleteOutlined, WarningOutlined,FileExclamationOutlined } from '@ant-design/icons';
import axios from 'axios';
import { useLocation,NavLink,useParams } from 'react-router-dom';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';



const { Option } = Select;
const { Dragger } = Upload;
const { DirectoryTree } = Tree;


const MenuProduct = (props) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [products, setProducts] = useState([]);
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [treeData, setTreeData] = useState([]);
  const [treeVisibleData, setTreeVisibleData] = useState([]);
  const [menuData, setMenuData] = useState([]);
  const [catTree, setCatTree] = useState([]);
  const [dontMount, setDontMount] = useState(false);
  const[userRole,setUserRole] = useState("");
  const [error,setError] = useState();
  const { mEnc } = useParams();
  const [searchQuery, setSearchQuery] = useState('');
// console.log('products from product page',products)
// console.log('treeData',treeData)

 

  const modules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      [{ header: 1 }, { header: 2 }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['blockquote', 'code-block'],
      [{ script: 'sub' }, { script: 'super' }],
      [{ indent: '-1' }, { indent: '+1' }],
      [{ direction: 'rtl' }],
      [{ color: [] }, { background: [] }],
      [{ font: [] }],
      [{ align: [] }],
      // ['image'],
      ['clean'],
    ],
  };

  const formats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'code-block',
    'list',
    'bullet',
    'script',
    'indent',
    'direction',
    'color',
    'background',
    'font',
    'align',
    // 'image',
    'clean',
  ];

  useEffect(() => {
    getTreeProducts();
    getTreeVisible();
  }, []);

  useEffect(() => {

    getProducts();
    getMenu();
    const paramValue = searchParams.get('add');
    paramValue ? setOpen(true) : setOpen(false);
   
  setDontMount(false)
  }, [props,location.search]);


  useEffect(() => {
    // Filter and update the state when the component mounts
     if(!dontMount){
      const filteredData = treeData.filter(obj => {
        const categoryValue = obj.value;
        return products.some(item => item.category === categoryValue);
      });
    //  console.log('aa',filteredData)
      setCatTree(filteredData);
     }
  }, [products]);

  

const getProducts = async () => {
  let productParam = searchParams.get('d');
  let menuParam = searchParams.get('mEnc');
  const session =sessionStorage.getItem("user") ? JSON.parse(sessionStorage.getItem("user")) :null;
  const userString = session? session.uuid :'';
  const role = session ? session.role : ''
  setUserRole(role)

  try {
    let response;

    if (productParam) {
      response = await axios.post(`${process.env.REACT_APP_API_URL}/products_page`, { productParam });
    } else {
      response = await axios.post(`${process.env.REACT_APP_API_URL}/products_page`, { menuParam });
    }
    console.log('asasasasa',response.data)
    setProducts(response.data);
    setLoading(false);

  } catch (error) {
    console.log(error);
   
      console.error(error.response.data.msg);
      // message.error(error.response.data.msg);
      setError(error.response.data.msg);
      setTimeout(function() {
        setError();
      }, 3000);
   
  }
};


  const getTreeProducts = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/tree_category`);
      const filteredResponse = response.data.map(item => ({
        ...item,
        children: item.children.filter(child => child.title !== "all")
    }));
      setTreeData(filteredResponse);
     
    } catch (error) {
      console.log(error);
     
        console.error(error.response.data.msg);
        // message.error(error.response.data.msg);
        setError(error.response.data.msg);
        setTimeout(function() {
          setError();
        }, 3000);
   
    }
  };

  const getTreeVisible = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/departments_tree`);
      const filteredResponse = response.data.map(item => ({
        ...item,
        children: item.children.filter(child => child.title !== "all")
    }));
      setTreeVisibleData(filteredResponse)
   
    } catch (error) {
      console.log(error);
      
        console.error(error.response.data.msg);
        // message.error(error.response.data.msg);
        setError(error.response.data.msg);
        setTimeout(function() {
          setError();
        }, 3000);

    }
  };

  const getMenu = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/menu`);
      setMenuData(response.data);
      
    } catch (error) {
      console.log(error);
  
        console.error(error.response.data.msg);
        // message.error(error.response.data.msg);
        setError(error.response.data.msg);
        setTimeout(function() {
          setError();
        }, 3000);
   
    }
  };

  const showModal = () => {
    setOpen(true);
  };

  const handleOk = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setOpen(false);
    }, 3000);
  };

  const onFinishFailed = errorInfo => {
    console.log('Failed:', errorInfo);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const { Meta } = Card;

  const onSelect = async(keys, info) => {
    console.log('Trigger Select', keys, info);
    const paramValue = searchParams.get('mEnc');

    try {
  
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/products_by_cat`, { catUuid:keys, menu:paramValue });
      setDontMount(true);
      setProducts(response.data);
  
    } catch (error) {
      console.log(error);
     
        console.error(error.response.data.msg);
        // message.error(error.response.data.msg);
        setError(error.response.data.msg);
        setTimeout(function() {
          setError();
        }, 3000);
    
    }
  };

  const onExpand = (keys, info) => {
    console.log('Trigger Expand', keys, info);
  };

  const onFinish = async (values) => {
    // console.log('values',values)

    let type
    const whichType = values.visibleTo.split("-");

    if(whichType.length > 5){
       type = 'sub'
    }

    

    const newValue = {
      documentType:values.documentType,
      menu:values.menu,
      spreadsheetLinks:values.spreadsheetLinks,
      textEditor:values.textEditor,
      title:values.title,
      uploadFiles:values.uploadFiles,
      category: values.category.split("-").slice(-5).join("-"),
      visibleTo: values.visibleTo.split("-").slice(0,5).join("-"),
      visibleToSubDept: values.visibleTo.split("-").slice(-5).join("-"),
      type:type
    }
    const formData = new FormData();

    // Append regular files from Drag and Drop area
    fileList.forEach((file) => {
      formData.append('files', file.originFileObj);
    });
     

    try {
      // Append other form values to the FormData
      for (const key in newValue) {
        formData.append(key, newValue[key]);
      }
      
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/products`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      
      // console.log('Product created:', response.data);
      getProducts();
      handleCancel();
      setFileList([]);

    } catch (error) {
     
      console.log(error);
   
        console.error(error.response.data.msg);
        // message.error(error.response.data.msg);
        setError(error.response.data.msg);
        setTimeout(function() {
          setError();
        }, 3000);
    
    }
  };

  const deleteProduct = async (productId) => {
    try {
      await axios.delete(`${process.env.REACT_APP_API_URL}/products/${productId}`);
      // console.log('Product deleted:', productId);
      getProducts();
    } catch (error) {
      console.log(error);
     
        console.error(error.response.data.msg);
        // message.error(error.response.data.msg);
        setError(error.response.data.msg);
        setTimeout(function() {
          setError();
        }, 3000);
   
    }
  };








  return (
    <>
     
      <div className='tableTitle productCompTitle'>
      {error && <div className='errorApi'>{error}</div>}
        <Input
          className='productSearch'
          type="text"
          placeholder="Search products..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
        {/* {userRole == 'admin'?<Button type='primary' onClick={showModal}>
          Add Document/Product
        </Button>:null} */}
      </div>

       <div className='productComponent'>
        <div className='treeView'>
          <h3>Document Category/Sub-Category</h3>
          <DirectoryTree onSelect={onSelect} onExpand={onExpand} treeData={catTree} />
        </div>
        {products.length != 0 ?
        <div className='productDetails'>
          {products
                  .filter((product) => product.title.toLowerCase().includes(searchQuery.toLowerCase()))
                  .map((product) => (
            <Card
            className={userRole == 'admin' ? 'admin'  :'user'}
              key={product.uuid}
              style={{
                marginTop: 16,
              }}
              actions={[
          
                <div key='View'>
                  <NavLink to={`/product_view?reqU=${product.uuid}`}> <FolderViewOutlined key='View Detail' /></NavLink>
              </div>,
                // <div onClick={() => deleteProduct(product.uuid)} key='Delete'>
                //   {userRole == 'admin' ?  <DeleteOutlined  /> :null}
                // </div>,
                // <div
                //   onClick={() =>
                //     updateProduct(product.uuid, {
                //       ...product,
                //       title: 'Updated Title',
                //     })
                //   }
                //   key='Edit'
                // >
                //   <EditOutlined />
                // </div>,
              ]}
            >
              <Skeleton loading={loading} paragraph={{ rows: 2 }} active>
                <Meta avatar={<InboxOutlined />} title={'Title: ' + product.title} description={'Doc Type: ' + product.documentType} />
              </Skeleton>
            </Card>
          ))}

          {products.length ? null :<div className='proError'> Oops! no products found <FileExclamationOutlined /></div>}
        </div>
          :<div className='proError'><WarningOutlined />Sorry no product found for this department</div>}
      
      </div>
    </>
  );
};

export default MenuProduct;
